import React from 'react'

type IconProps = {
  size?: number
  className?: string
}

export default function PapelAmassadoIcon({ size = 20, className }: IconProps) {
  return (
    <img
      src="/images/icons/papel-amassado.svg"
      alt="Papel Amassado"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  )
}
